export const CATEGORY_LOADING = "CATEGORY_LOADING";
export const CATEGORY_SUCCESS = "CATEGORY_SUCCESS";
export const CATEGORY_ERROR = "CATEGORY_ERROR";
export const SUB_CATEGORY_LOADING = "SUB_CATEGORY_LOADING";
export const SUB_CATEGORY_SUCCESS = "SUB_CATEGORY_SUCCESS";
export const SUB_CATEGORY_ERROR = "SUB_CATEGORY_ERROR";
export const MODAL_LIST_LOADING = "MODAL_LIST_LOADING";
export const MODAL_LIST_SUCCESS = "MODAL_LIST_SUCCESS";
export const MODAL_LIST_ERROR = "MODAL_LIST_ERROR";
export const ADD_TO_CART = "ADD TO CART";
export const UPDATE_SUCCESS = "UPDATE_SUCCESS"
export const CLEAR_CART = "CLEAR_CART"
export const SAVE_LOADER = "SAVE_LOADER"
export const SAVE_ERROR = "SAVE_ERROR"